var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Modal',{attrs:{"width":_vm.width,"ok-text":"关闭","cancel-text":""},on:{"on-visible-change":_vm.visibleChange},model:{value:(_vm._value),callback:function ($$v) {_vm._value=$$v},expression:"_value"}},[_c('embed',{attrs:{"type":"application/pdf","src":_vm._initValue,"width":_vm.width - 20,"height":_vm.height}})])
}
var staticRenderFns = []

export { render, staticRenderFns }